import React, { useState } from "react";

import "./Footer.css";
import MukemelLogo from "./../../assets/footernew.png";
import Newsletter from "../Newsletter/Newsletter";
import { useTranslation } from "react-i18next";
import categoryData from "../../api/categories"; // yolunu projenize göre ayarlayın
import { formatPage } from "../../utils/formatPage"; // URL'de kullanılacak slug formatı için
import LanguageSelector from "./../../components/LanguageSelector/LanguageSelector.js";
const Footer = () => {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);
  const [fadeClass, setFadeClass] = useState("");

  const toggleShowAll = () => {
    setFadeClass("fade-enter");
    setTimeout(() => {
      setShowAll((prev) => !prev);
      setFadeClass(""); // temizle
    }, 200); // 100ms animasyon süresi
  };

  const visibleCategories = showAll
    ? categoryData.category
    : categoryData.category.slice(0, 5);
  return (
    <>
      <section className="bgcolor p-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6 mt-4">
              <h6 className="textcolor footertitle300 text-uppercase">
                {t("footerbolum1")}
              </h6>
              <p className="mt-4 fw-14 textcolor">
                {t("footerbolum1desc")}
                <a
                  href="https://wa.me/905365049119"
                  target="__blank"
                  className="textcolor mx-1"
                >
                  +90 536 504 91 19​​
                </a>
              </p>
              <p>
                <a href="/faq" className="text-decoration-none textcolor fw-14">
                  {t("FAQs")}
                </a>
              </p>

              <p>
                <a
                  href="/shop"
                  className="text-decoration-none textcolor fw-14"
                >
                  {t("Shop")}
                </a>
              </p>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6 mt-4">
              <h6 className="textcolor footertitle300 text-uppercase">
                {t("Categories")}
              </h6>
              <p className="mt-4"></p>
              <>
                <div className={`fade-transition ${fadeClass}`}>
                  {visibleCategories.map((cat) => (
                    <p className="mb-3" key={cat.id}>
                      <a
                        href={`/category/${formatPage(cat.categoryname)}`}
                        className="textcolor text-decoration-none fw-14"
                      >
                        {t(cat.translationKey) || cat.categoryname}
                      </a>
                    </p>
                  ))}
                </div>
                {categoryData.category.length > 5 && (
                  <button
                    onClick={toggleShowAll}
                    className="btn text-decoration-none p-0 fw-bold mx-0"
                    style={{ color: "#741819" }}
                  >
                    {showAll ? (
                      <>
                        {t("Show Less")}
                        <i className="fa-solid fa-angles-up"></i>
                      </>
                    ) : (
                      <>
                        {t("Show More")}
                        <i className="fa-solid fa-angles-down"></i>
                      </>
                    )}
                  </button>
                )}
              </>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6 mt-4">
              <h6 className="textcolor footertitle300 text-uppercase">
                {t("About Mukemel")}
              </h6>
              <p className="mb-3 mt-4">
                <a
                  href="/about"
                  className="textcolor text-decoration-none fw-14"
                >
                  {t("About")}
                </a>
              </p>
              <p className="mb-3">
                <a
                  href="/blog"
                  className="textcolor text-decoration-none fw-14"
                >
                  {t("Blog")}
                </a>
              </p>

              <p className="mb-3">
                <a
                  href="/contact"
                  className="textcolor text-decoration-none fw-14"
                >
                  {t("Contact")}
                </a>
              </p>
              <p className="mb-3">
                <a
                  href="/secure-shopping-information"
                  className="textcolor text-decoration-none fw-14"
                >
                  {t("Secure Shopping Information")}
                </a>
              </p>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 mt-4">
              <h6 className="textcolor footertitle300 text-uppercase">
                {t("Email Sign-Up")}
              </h6>
              <p className="fw-14 mt-4 textcolor">
                <a
                  href="/"
                  className="textcolor me-1 fw-bold"
                  data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight"
                  data-bs-toggle="offcanvas"
                >
                  {t("Sign up")}
                </a>{" "}
                {""}
                {t("EmailSignUpDesc")}
              </p>

              <p>
                <a
                  data-bs-toggle="collapse"
                  href="#collapseExample"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                  className="text-decoration-none textcolor fw-14"
                >
                  {t("Follow us")}
                </a>
              </p>

              <div className="row">
                <div className="col-6">
                  {" "}
                  <p className="text-decoration-none textcolor fw-14 mb-2">
                    {t("SelectLanguage")}
                  </p>
                  <LanguageSelector />
                </div>
                <div className="col-6">
                  <p className="textcolor mb-2">{t("MobileApplications")}</p>
                  <a
                    href="https://apps.apple.com/us/app/m%C3%BCkemel/id6753164005"
                    target="__blank"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/1280px-Download_on_the_App_Store_Badge.svg.png"
                      alt="app store"
                      width={130}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bgcolor borderbottomcolor">
        <div className="container-fluid ">
          <div className="row justify-content-center">
            <div className="col-lg-12 justify-content-center p-3 text-center">
              <div className="collapse" id="collapseExample">
                <div className="row text-white justify-content-center">
                  <div className="bordertopcolor"></div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <h6 className="mb-3 text-decoration-none textcolor pt-3">
                      {t("Mükemel Follow us")}
                    </h6>
                    <a
                      href="https://www.facebook.com/mukemelofficial"
                      target="__blank"
                      className="textcolor mx-2"
                    >
                      <i className="fa-brands fa-facebook fa-xl "></i>
                    </a>
                    <a
                      href="https://x.com/mukemelcom"
                      target="__blank"
                      className="textcolor mx-2"
                    >
                      <i className="fa-brands fa-x-twitter fa-xl"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/mukemelcom/"
                      target="__blank"
                      className="textcolor mx-2"
                    >
                      <i className="fa-brands fa-instagram fa-xl"></i>
                    </a>
                    <a
                      href="https://www.linkedin.com/company/mukemelofficial/"
                      target="__blank"
                      className="textcolor mx-2"
                    >
                      <i className="fa-brands fa-linkedin fa-xl"></i>
                    </a>
                    <a
                      href="https://www.youtube.com/@mukemelcom"
                      target="__blank"
                      className="textcolor mx-2"
                    >
                      <i className="fa-brands fa-youtube fa-xl"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@mukemelcom"
                      target="__blank"
                      className="textcolor mx-2"
                    >
                      <i className="fab fa-tiktok fa-lg"></i>
                    </a>
                    <a
                      href="https://tr.pinterest.com/mukemelcom/"
                      target="__blank"
                      className="textcolor mx-2"
                    >
                      <i className="fab fa-pinterest fa-lg"></i>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-">
                    <h6 className="mb-3 text-decoration-none textcolor pt-3">
                      {t("Perfume Follow us")}
                    </h6>
                    <a
                      href="https://www.instagram.com/mukemel_perfume/"
                      target="__blank"
                      className="textcolor mx-2"
                    >
                      <i className="fa-brands fa-instagram fa-xl"></i>
                    </a>

                    <a
                      href="https://www.tiktok.com/@mukemel_perfume"
                      target="__blank"
                      className="textcolor mx-2"
                    >
                      <i className="fab fa-tiktok fa-lg"></i>
                    </a>
                    <a
                      href="https://www.facebook.com/Mukemelperfume"
                      target="__blank"
                      className="textcolor mx-2"
                    >
                      <i className="fa-brands fa-facebook fa-xl "></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bgcolor ">
        <div className="container">
          <div className="row pb-5 pt-4">
            <div className="col-lg-12 text-center pt-3 d-none d-sm-block">
              <a
                href="/terms-and-conditions"
                className="textcolor text-decoration-none mx-3 fw-14"
              >
                {t("Terms and Conditions")}
              </a>
              <a
                href="/shipping-and-delivery"
                className="textcolor text-decoration-none mx-3 fw-14"
              >
                {t("Shipping and Delivery")}
              </a>
              <a
                href="/privacy-policy"
                className="textcolor text-decoration-none mx-3 fw-14"
              >
                {t("Privacy Policy")}
              </a>
              <a
                href="/installment-options"
                className="textcolor text-decoration-none mx-3 fw-14"
              >
                {t("Installment Options")}
              </a>
              <a
                href="/return-policy"
                className="textcolor text-decoration-none mx-3 fw-14"
              >
                {t("Return Policy")}
              </a>
            </div>
            <div className="col-12 text-center d-block d-sm-none">
              <p>
                <a
                  href="/terms-and-conditions"
                  className="textcolor text-decoration-none fw-14"
                >
                  {t("Terms and Conditions")}
                </a>
              </p>
              <p>
                <a
                  href="/shipping-and-delivery"
                  className="textcolor text-decoration-none fw-14"
                >
                  {t("Shipping and Delivery")}
                </a>
              </p>
              <p>
                <a
                  href="/privacy-policy"
                  className="textcolor text-decoration-none fw-14"
                >
                  {t("Privacy Policy")}
                </a>
              </p>
              <p>
                <a
                  href="/installment-options"
                  className="textcolor text-decoration-none mx-3 fw-14"
                >
                  {t("Installment Options")}
                </a>
              </p>
              <p>
                <a
                  href="/return-policy"
                  className="textcolor text-decoration-none mx-3 fw-14"
                >
                  {t("Return Policy")}
                </a>
              </p>
            </div>
            <div className="col-lg-12 text-center mt-3">
              <a href="/">
                <img
                  src={MukemelLogo}
                  alt="Mukemel Logo"
                  className="mt-3"
                  width={150}
                />
              </a>
            </div>
            <div className="col-lg-12 text-center mt-5 textcolor">
              <p>​ {t("MÜKEMEL ® 2025 All Rights Reserved")}.</p>
            </div>
          </div>
        </div>
      </section>

      <Newsletter />
    </>
  );
};

export default Footer;
